import * as React from 'react';

interface SelectProps {
    selectProps?: React.SelectHTMLAttributes<HTMLSelectElement>;
    options: KeyValue[];
    error?: boolean;
}

interface KeyValue {
    value?: string;
    text: string;
}

export const NoLabelSelect = React.forwardRef<HTMLSelectElement, SelectProps>((props, ref) => (
    <div
      className={`select ${props.error ? 'error' : ''} ${props.selectProps && props.selectProps.value ? 'hasValue' : ''}`}
    >
      <select
        {...props.selectProps}
        ref={ref}
      >
        {props.options.map(option => <option key={option.value} value={option.value}>{option.text}</option>)}
      </select>
    </div>
  ));